import { Options } from 'react-overlays/usePopper';

export const TOP = 'top';
export const BOTTOM = 'bottom';
export const RIGHT = 'right';
export const LEFT = 'left';

export const TOP_START = 'top-start';
export const TOP_END = 'top-end';
export const BOTTOM_START = 'bottom-start';
export const BOTTOM_END = 'bottom-end';
export const RIGHT_START = 'right-start';
export const RIGHT_END = 'right-end';
export const LEFT_START = 'left-start';
export const LEFT_END = 'left-end';

export type BasePlacement = typeof TOP | typeof BOTTOM | typeof RIGHT | typeof LEFT;

export type VariationPlacement =
  | typeof TOP_START
  | typeof TOP_END
  | typeof BOTTOM_START
  | typeof BOTTOM_END
  | typeof RIGHT_START
  | typeof RIGHT_END
  | typeof LEFT_START
  | typeof LEFT_END;

export type Placement = BasePlacement | VariationPlacement;

export const allPlacements = [TOP_START, TOP, TOP_END, BOTTOM_START, BOTTOM, BOTTOM_END, LEFT_START, LEFT, LEFT_END, RIGHT_START, RIGHT, RIGHT_END];

export interface IBasePlacementProps {
  placement?: BasePlacement;
}

export interface IPlacementProps {
  placement?: Placement;
}

export const isOnTopOrBottom = (placement: Placement) => [TOP, TOP_END, TOP_START, BOTTOM_START, BOTTOM, BOTTOM_END].includes(placement);

// Ensures Placement from popper matches one of our Placements from above, if not default to TOP
export const getPlacement = (placement: Options['placement']): Placement => (allPlacements.find((p) => p === placement) as Placement) ?? TOP;

export const getBasePlacement = (placement: Options['placement'] = BOTTOM): BasePlacement =>
  ([TOP, BOTTOM, LEFT, RIGHT].find((pos) => placement.includes(pos)) as BasePlacement) ?? BOTTOM;
